<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">OCRデータメール送信</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txt_orderCode" #txt_orderCode [subid]="'txt_orderCode'"
              [(ngModel)]="kymw2200Model.orderCode" [required]="true" [catalogIDField]="lbl_DelivCatalogId"
              (ngModelChange)="eventOrderCode_CHANGEHandler()" [autofocus]="true" [tabindex]="0">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="lbl_DelivCatalogId" #lbl_DelivCatalogId readonly>
            </div>
        </div>

        <div>
          <h2>送信先</h2>
          <div class="column-list">
            <label class="list-input-title">OCR印刷会社</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_CodeValueName" #cmb_CodeValueName [subid]="'cmb_CodeValueName'"
                [(ngModel)]="kymw2200Model.codeValueName" [codeDiv]="'ctp003'" [required]="true" [blank]="false"
                [labelField]="'codeValueName'" (loadCompleted)="eventCodeValue_CHANGEHandler()"
                [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-code-combo-box>
            </div>

            <label class="list-input-title">メールアドレス</label>
            <div class="list-input-content">
              <input type="text" class="text-label-required" id="txt_MailAddress" #txt_MailAddress
                [(ngModel)]="kymw2200Model.mailAddress" plessInputTextSub [maxlength]="50"
                [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.]'" (input)="eventMailAddress_CHANGEHandler()"
                [tabindex]="0" autocomplete="off" />
              <button id="btn_RegistAddress" #btn_RegistAddress class="btn-secondary" style="min-width:120px"
                (click)="eventRegistAddress_CLICKHandler()" forcedEnabledMode="" [tabindex]="0">アドレス登録</button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" #btn_Set class="btn-primary" (click)="eventSet_CLICKHandler()" forcedEnabledMode=""
            [tabindex]="0">実行</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>